import i18next from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import he from './he.json';
import hi from './hi.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import nl from './nl.json';
import pt from './pt.json';
import ru from './ru.json';
import tr from './tr.json';
import zh_CMN from './zh-cmn.json'; // eslint-disable-line camelcase
import zh_TW from './zh-tw.json'; // eslint-disable-line camelcase

export {ar, de, en, es, fr, he, hi, it, ja, ko, nl, pt, ru, tr, zh_CMN, zh_TW}; // eslint-disable-line camelcase
export const defaultLanguage = 'en';

export const languages = [
    {label: 'English', value: 'en', rtl: false}, // English
    {label: 'Español', value: 'es', rtl: false}, // Spanish
    {label: 'Dutch', value: 'nl', rtl: false}, // Dutch
    {label: 'Français', value: 'fr', rtl: false}, // French
    {label: 'Deutsch', value: 'de', rtl: false}, // German
    {label: 'Italiano', value: 'it', rtl: false}, // Italian
    {label: 'Português', value: 'pt', rtl: false}, // Portuguese
    {label: '简体中文', value: 'zh_CMN', rtl: false}, // Chinese (Simplified)
    {label: '繁体中文', value: 'zh_TW', rtl: false, noBold: true}, // Chinese (Traditional)
    {label: '日本語', value: 'ja', rtl: false}, // Japanese
    {label: '한국어', value: 'ko', rtl: false}, // Korean
    {label: 'Русский', value: 'ru', rtl: false}, // Russian
    {label: 'Türkçe', value: 'tr', rtl: false}, // Turkish
    {label: 'हिन्दी', value: 'hi', rtl: false}, // Hindi
    {label: 'עברית', value: 'he', rtl: true}, // Hebrew
    {label: 'اللغة العربية', value: 'ar', rtl: true}, // Arabic
];

const languageCodes = languages.map(language => language.value);

const resources = {};
languages.forEach(language => {
    resources[language.value] = {translation: module.exports[language.value]};
});

export const initTranslations = (language) => new Promise((resolve) => {
    i18next
        .use(LngDetector)
        .init({
            resources,
            nsSeparator: false,
            keySeparator: false,
            detection: {
                caches: ['localStorage'],
                lookupLocalStorage: 'cielo24.language',
            },
        });

    if (language === 'autodetect') language = i18next.language;
    if (!languageCodes.includes(language)) language = defaultLanguage;

    return resolve(language);
});



// WEBPACK FOOTER //
// ./locale/index.js